import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { CommentsSectionHeader } from '@components/CaseDetails/CommentsSection/CommentsSectionHeader/CommentsSectionHeader';
import { CommentsTable } from '@components/CaseDetails/CommentsSection/CommentsTable/CommentsTable';
import { CommentsProvider } from '@components/CaseDetails/CommentsSection/CommentsContext/CommentsContext';
import { AddCommentModal } from '@components/CaseDetails/CommentsSection/CommentModal/AddCommentModal/AddCommentModal';
import {
	DeleteCommentModal
} from '@components/CaseDetails/CommentsSection/CommentModal/DeleteCommentModal/DeleteCommentModal';
import {
	EditCommentModal
} from '@components/CaseDetails/CommentsSection/CommentModal/EditCommentModal/EditCommentModal';
import {
	NoCommentsMessage
} from '@components/CaseDetails/CommentsSection/CommentsTable/NoCommentsMessage/NoCommentsMessage';

const useStyles = makeStyles(() => ({
	root: {
		position: 'relative',
		maxHeight: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
	},
}));

export const CommentsSection: React.FC = () => {
	const classes = useStyles();

	return (
		<CommentsProvider>
			<Box className={classes.root}>
				<AddCommentModal />
				<EditCommentModal />
				<DeleteCommentModal	/>
				<CommentsSectionHeader />
				<CommentsTable />
				<NoCommentsMessage />
			</Box>
		</CommentsProvider>
	);
};
